import { tasksApi } from 'modules/cm/api';
import { Dispatch } from 'redux';
import { RootState } from 'store/configureStore';
import { mapTaskStatus } from '../mappers/toApi';
import { actions } from '../store';
import { Action } from '../store/store';
import { ITask, TaskStatuses } from '../Task';

const switchStatus = (newStatus: TaskStatuses, setTaskStatus: (task: ITask) => Action) => (
  caseId: string,
  task: ITask,
) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(actions.taskActionStart(task));
    try {
      await tasksApi(caseId).switchStatus(task.id, mapTaskStatus(newStatus));

      dispatch(setTaskStatus(task));
      dispatch(actions.taskActionFinish(task));
    } catch (e) {
      dispatch(actions.taskActionFinish(task));
    }
  };
};

export default switchStatus;
